import {
  trigger, state, style, animate, transition,
} from '@angular/animations';

export const animations = [
  trigger('fadeIn', [
    state('show', style({ opacity: 1 })),
    state('hide', style({ opacity: 0 })),
    transition('* => show', animate('200ms 100ms ease-out')),
    transition('show => hide', animate('200ms ease-out')),
  ])];
